




































import BaseComponent from '@/components/base-component.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectSortOptions from '@/components/UI/select-sort-options.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    UiFilterContainer,
    UiSelectSortOptions,
    UiDatePicker
  }
})
export default class PlanningCycleFilters extends BaseComponent {
  @Prop()
  public menuMode?: boolean;

  filter: any = {};

  descending = false;
  sortBy = null;
  sortOptions = [];

  mounted() {
    this.buildSortOptions();
  }

  buildSortOptions() {
    this.descending = false;
    this.sortBy = null;
    this.sortOptions = [];
    this.sortOptions.push({ text: 'Tipo', value: 'tipo' });
    this.sortOptions.push({ text: 'Início', value: 'dataInicio' });
    this.sortOptions.push({ text: 'Fim', value: 'dataFim' });
    this.sortOptions.push({ text: 'Fechamento', value: 'automatico' });
    this.sortOptions.push({ text: 'Situação', value: 'aberto' });
  }

  onSortChange(by, desc) {
    this.sortBy = by;
    this.descending = desc;
  }

  onChangeFilter() {
    if (this.menuMode) {
      return;
    }

    this.filter.oldTextoBusca = this.filter.textoBusca;
    this.emitFilter();
  }

  emitFilter() {
    if (this.menuMode) {
      this.filter.descending = this.descending;
      this.filter.sortBy = this.sortBy;
    } else {
      this.filter.sortBy = null;
    }
    this.$emit('filter', this.filter);
  }
}
